import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from "react-bootstrap";
import { connect } from "react-redux";
import { PromoChange } from "../../redux/actions/modal";
import { sendNotification } from "../../redux/actions/sendNotification";
import { getUserPosition } from "../../redux/actions/getUserPosition";
import {
  Titulo,
  Conteudo,
  Img,
  Link,
  Valor,
  Promocao,
  Send
} from "../../redux/actions/promo";
class NewPromo extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleClose = this.handleClose.bind(this);
    this.state = {};
  }
  handleClose() {
    this.props.PromoChange(false);
  }
  render() {
    var message = {
      app_id: "4030c1ae-619f-4fea-8308-b4ac7e92f695",
      contents: {
        en: "adicionou uma nova Promoção"
      },
      headings: {
        en: this.props.user ? this.props.user.nome : "Usuario"
      },
      filters: [
        {
          field: "location",
          radius: "20000",
          lat: this.props.user ? parseFloat(this.props.user.lat) : 0,
          long: this.props.user ? parseFloat(this.props.user.lng) : 0
        }
      ],
      data: {
        id: this.props.user ? this.props.user.uid : "",
        cat: this.props.user ? this.props.user.categoria : "",
        logo: this.props.user ? this.props.user.img : ""
      }
    };
    return (
      <Modal show={this.props.promo} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Promoção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FieldGroup
            id="formControlsText"
            type="text"
            label="Título"
            placeholder="Ex: Promoção Imperdivel"
            onChange={e => this.props.Titulo(e.target.value)}
            value={this.props.title}
          />
          <FormGroup
            controlId="formControlsTextarea"
            onChange={e => this.props.Conteudo(e.target.value)}
            value={this.props.content}
          >
            <ControlLabel>Descrição do Produto / Serviço</ControlLabel>
            <FormControl
              componentClass="textarea"
              placeholder="Digite aqui um texto de até 120 Caracteres."
            />
          </FormGroup>
          <FieldGroup
            id="formControlsFile"
            type="file"
            label="Imagem"
            help="Imagem de destaque para a promoção."
            onChange={e => this.props.Img(e)}
          />
          {this.props.sendState}
          <FieldGroup
            id="formControlsText"
            type="number"
            label="Valor Habitual"
            placeholder="Ex: 30.00"
            onChange={e => this.props.Valor(e.target.value)}
            value={this.props.valor}
          />
          <FieldGroup
            id="formControlsText"
            type="number"
            label="Valor Promocional"
            placeholder="Ex: 15.00"
            onChange={e => this.props.Promocao(e.target.value)}
            value={this.props.Vpromo}
          />
          <ControlLabel>
            Obs: A promoção tem o prazo de validade de 7 dias, após esse período
            a promoção expirará. Mas você poderá cadastrar uma nova =)
          </ControlLabel>
          <FieldGroup
            className={css(styles.linkpromo)}
            id="formControlsText"
            type="text"
            label=""
            placeholder="Link da promoção"
            onChange={e => this.props.Link(e.target.value)}
            value={this.props.link}
          />
        </Modal.Body>
        <Modal.Footer>
          {this.props.sendState}
          <Button
            bsStyle="success"
            onClick={() => {
              Promise.all([this.props.sendNotification(message)]).then(() => {
                this.props.Send(
                  this.props.content,
                  this.props.title,
                  this.props.Vpromo,
                  this.props.valor,
                  this.props.user.email,
                  this.props.img,
                  this.props.link,
                  7
                );
              });
            }}
          >
            Enviar
          </Button>
          <Button onClick={this.handleClose}>Cancelar</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  linkpromo: {
    display: "none"
  }
});
const mapStateToProps = state => {
  return {
    promo: state.modal.promo,
    title: state.promo.title,
    content: state.promo.content,
    img: state.promo.img,
    imgError: state.promo.imgError,
    link: state.promo.link,
    valor: state.promo.valor,
    Vpromo: state.promo.Vpromo,
    sendState: state.promo.sendState,
    user: state.user.user
  };
};
function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}
export default connect(
  mapStateToProps,
  {
    PromoChange,
    Titulo,
    Conteudo,
    Img,
    Link,
    Valor,
    Promocao,
    Send,
    sendNotification
  }
)(NewPromo);



// WEBPACK FOOTER //
// ./src/assets/modalNovaPromo/index.js